<div class="comm-layout-container h-100">
    <app-communication-segment *ngIf="settings && settings.allowSegmentation" [screenType]="communicationScreenType"></app-communication-segment>
    <app-template-form style="min-width:360px"
                       [roleList]="roleList"
                       [previousRolesList]="previousRolesList"
                       [selectedTemplateData]="selectedTemplateData"
                       [viewMode]="viewMode"
                       (selectedRolesEvent)="selectedRoles($event)"></app-template-form>
    <app-communication-template-view></app-communication-template-view>
</div>
